const configLocalStorageProvider = localStorageServiceProvider => {
	localStorageServiceProvider.setPrefix('ocaa');
	localStorageServiceProvider.setStorageType('sessionStorage');
};
configLocalStorageProvider.$inject = ['localStorageServiceProvider'];
export default configLocalStorageProvider;
